/* @flow */
import * as React from 'react';

import { CSSTransitionGroup } from 'react-transition-group';
import Glyph from 'components/Glyph.jsx';
import Link from 'components/Link.jsx';
import RecentMessages from 'groups/components/RecentMessages.jsx';

import './styles/RecentView.scss';

type Props = {
  hide: Function,
};

class RecentView extends React.Component<Props> {
  render() {
    const { hide } = this.props;

    return (
      <div className="RecentView">
        <div className="RecentView-mask" onClick={hide} />
        <Link color="pitch" className="RecentView-closeButton" onClick={hide}>
          <Glyph name="close-btn" />
        </Link>
        <div className="RecentView-view">
          <CSSTransitionGroup
            className="RecentView-view-inner"
            transitionAppear
            transitionEnterTimeout={1000}
            transitionAppearTimeout={1000}
            transitionLeaveTimeout={1000}
            transitionName="RecentView-view-inner-">
            <RecentMessages key="recent" />
          </CSSTransitionGroup>
        </div>
      </div>
    );
  }
}

export default RecentView;
